import {
  GET_CLIENTCONTRACTS_REQUESTED,
  GET_CLIENTCONTRACTS_SUCCESS,
  GET_CLIENTCONTRACTS_FAILED,
  ADD_CLIENTCONTRACTS_REQUESTED,
  ADD_CLIENTCONTRACTS_SUCCESS,
  ADD_CLIENTCONTRACTS_FAILED,
  GET_CLIENTCONTRACT_REQUESTED,
  GET_CLIENTCONTRACT_SUCCESS,
  GET_CLIENTCONTRACT_FAILED,
  GET_PROLONGCALCULATE_REQUESTED,
  GET_PROLONGCALCULATE_SUCCESS,
  GET_PROLONGCALCULATE_FAILED,
  ADD_PROLONGCALCULATE_REQUESTED,
  ADD_PROLONGCALCULATE_SUCCESS,
  ADD_PROLONGCALCULATE_FAILED,
  CHANGE_CLIENTCONTRACT_REQUESTED,
  CHANGE_CLIENTCONTRACT_SUCCESS,
  CHANGE_CLIENTCONTRACT_FAILED,
  GET_OPERATIONSCONTRACT_REQUESTED,
  GET_OPERATIONSCONTRACT_SUCCESS,
  GET_OPERATIONSCONTRACT_FAILED,
  CHANGE_CONTRACTSTATUSES_REQUESTED,
  CHANGE_CONTRACTSTATUSES_SUCCESS,
  CHANGE_CONTRACTSTATUSES_FAILED,
  GET_TRANSACTIONS_REQUESTED,
  GET_TRANSACTIONS_SUCCESS,
  GET_TRANSACTIONS_FAILED,
  CHANGE_POSITIONSCONTRACT_REQUESTED,
  CHANGE_POSITIONSCONTRACT_SUCCESS,
  CHANGE_POSITIONSCONTRACT_FAILED,
  TRANSFER_DEALS_REQUESTED,
  TRANSFER_DEALS_SUCCESS,
  TRANSFER_DEALS_FAILED,
  GET_INVENTORIES_REQUESTED,
  GET_INVENTORIES_SUCCESS,
  GET_INVENTORIES_FAILED,
  GET_INVENTORYDEALS_REQUESTED,
  GET_INVENTORYDEALS_SUCCESS,
  GET_INVENTORYDEALS_FAILED,
  GET_DEALSFORTRANSFER_REQUESTED,
  GET_DEALSFORTRANSFER_SUCCESS,
  GET_DEALSFORTRANSFER_FAILED,
  TRANSFER_SALED_REQUESTED,
  TRANSFER_SALED_SUCCESS,
  TRANSFER_SALED_FAILED,
  OVERESTIMATION_DEALS_REQUESTED,
  OVERESTIMATION_DEALS_SUCCESS,
  OVERESTIMATION_DEALS_FAILED,
  CANCEL_OPERATION_REQUESTED,
  CANCEL_OPERATION_SUCCESS,
  CANCEL_OPERATION_FAILED,
  GET_PRINTEDFORM_REQUEST,
  GET_PRINTEDFORM_SUCCESS,
  GET_PRINTEDFORM_FAILED,
  PROLONG_CALCULATE_CLEAR,
  CHANGE_CONTRACT_CLEAR,
  CONTRACT_ID_CLEAR,
  CLIENT_CONTRACT_CLEAR,
  CONTRACT_STATE_RESET,
  CONTRACT_SAVE_RESET,
  CANCEL_CONTRACT_REQUEST,
  CANCEL_CONTRACT_SUCCESS,
  CANCEL_CONTRACT_FAILED,
  MODAL_ERROR_CLEAR,
  TRANSFER_TO_RETENTION_REQUESTED,
  TRANSFER_TO_RETENTION_SUCCESS,
  TRANSFER_TO_RETENTION_FAILED,
  SWITCH_CONTRACT_JEWELLERY,
  SWITCH_CONTRACT_THINGS,
  SWITCH_CONTRACT_CARS,
  CONTRACT_ERROR_CLEAR,
  SET_SELECTED_ITEMS,
  RESET_SELECTED_ITEMS,
  GET_WEB_FORM_SUCCESS,
  RESET_WEB_FORM,
  GET_PARTIAL_QUENCHING_DATA_REQUESTED,
  GET_PARTIAL_QUENCHING_DATA_SUCCESS,
  GET_PARTIAL_QUENCHING_DATA_FAILED,
  PARTIAL_QUENCHING_DATA_CLEAR,
  CONTRACT_PARTIAL_QUENCHING_REQUESTED,
  CONTRACT_PARTIAL_QUENCHING_SUCCESS,
  CONTRACT_PARTIAL_QUENCHING_FAILED,
  STATE_MODAL_ADD_CONTRACT,
  OVERESTIMATION_REQUEST_SUCCESS,
  SET_LOAD_PRA_FILE,
  CHANGE_STATE_PRA_MODAL,
  STATE_LOADER,
  LOAD_PRA_FILE,
  LOAD_PRA_SUCCESS,
  OPEN_ALERT_PRA,
  LOAD_PRA_FAILED,
  GET_ACCEPTANCE_CERTIFICATE,
  CHANGE_CONTRACTSTATUSES_REFUND_REQUESTED,
  CHANGE_CONTRACTSTATUSES_CLOSE_REQUESTED,
  GET_CLIENTSCOUNT_RERQUEST,
  GET_CLIENTSCOUNT_SUCCESS,
  GET_CLIENTSCOUNT_FAILED,
  RESET_CLIENTS_COUNT,
  GET_PAYMENTS_ANNUITY_SUCCESS,
  GET_PAYMENTS_ANNUITY_FAILED,
  GET_PAYMENTS_ANNUITY_REQUESTED,
  PAY_ANNUITY_PERIOD_SUCCESS,
  PAY_ANNUITY_PERIOD_FAILED,
  PAY_ANNUITY_PERIOD_REQUESTED,
  GET_CALC_ANNUITY_CLOSE_DEAL_REQUESTED,
  GET_CALC_ANNUITY_CLOSE_DEAL_SUCCESS,
  GET_CALC_ANNUITY_CLOSE_DEAL_FAILED,
  CLOSE_ANNUITY_DEAL_REQUESTED,
  CLOSE_ANNUITY_DEAL_SUCCESS,
  CLOSE_ANNUITY_DEAL_FAILED,
  SET_MODAL_ERROR,
  CLOSE_ANNUITY_STATE, ANNUITY_PERIOD_STATE, GET_PRINTED_FORM_AUTO_LOMBARD_REQUEST
} from './actionTypes'
import { contractStatuses } from '../../helpers/data-constants'

export const getAcceptanceCertificate = payload => ({
  type: GET_ACCEPTANCE_CERTIFICATE,
  payload
})

export const loadPraFailed = payload => ({
  type: LOAD_PRA_FAILED,
  payload
})
export const alertPraState = () => ({
  type: OPEN_ALERT_PRA
})
export const loadPraSuccess = payload => ({
  type: LOAD_PRA_SUCCESS,
  payload
})
export const loadPra = payload => ({
  type: LOAD_PRA_FILE,
  payload
})

export const stateLoader = payload => ({
  type: STATE_LOADER,
  payload
})

export const changedStatePraModal = payload => ({
  type: CHANGE_STATE_PRA_MODAL,
  payload
})

export const setLoadPraFile = payload => ({
  type: SET_LOAD_PRA_FILE,
  payload
})

export const isModalAddContract = payload => ({
  type: STATE_MODAL_ADD_CONTRACT,
  payload
})

export const setSelectedItems = (payload) => ({
  type: SET_SELECTED_ITEMS,
  payload
})

export const resetSelectedItems = () => ({
  type: RESET_SELECTED_ITEMS
})

export const getClientContracts = (items) => ({
  type: GET_CLIENTCONTRACTS_REQUESTED,
  payload: {
    id: items.id,
    size: items.size,
    page: items.page,
    filters: {
      status: items.status,
      dealType: items.dealType,
      cashBoxIds: items.cashBoxIds,
      clientIds: items.clientIds,
      dealIds: items.dealIds,
      dealTypes: items.dealTypes,
      dealDuration: items.dealDuration,
      graceFrom: items.graceFrom,
      graceTo: items.graceTo,
      delayFrom: items.delayFrom,
      delayTo: items.delayTo,
      startDate: items.startDate,
      endDate: items.endDate
    },
    descending: items.descending,
    sortBy: items.sortBy,
    fields: items.fields
  }
});

export const getClientContractsSuccess = payload => ({
  type: GET_CLIENTCONTRACTS_SUCCESS,
  payload,
})

export const getClientContractsFailed = payload => ({
  type: GET_CLIENTCONTRACTS_FAILED,
  payload,
})

export const addContract = (newContract, clientId) => ({
  type: ADD_CLIENTCONTRACTS_REQUESTED,
  newContract,
  clientId
})

export const addContractSuccess = payload => ({
  type: ADD_CLIENTCONTRACTS_SUCCESS,
  payload
})

export const addContractFailed = payload => ({
  type: ADD_CLIENTCONTRACTS_FAILED,
  payload
})

export const getClientContract = contractId => ({
  type: GET_CLIENTCONTRACT_REQUESTED,
  contractId
})

export const getClientContractSuccess = payload => ({
  type: GET_CLIENTCONTRACT_SUCCESS,
  payload,
})

export const getClientContractFailed = payload => ({
  type: GET_CLIENTCONTRACT_FAILED,
  payload,
})

export const getProlongCalculate = payload => ({
  type: GET_PROLONGCALCULATE_REQUESTED,
  payload
})

export const getProlongCalculateSuccess = payload => ({
  type: GET_PROLONGCALCULATE_SUCCESS,
  payload
})

export const getProlongCalculateFailed = payload => ({
  type: GET_PROLONGCALCULATE_FAILED,
  payload
})

export const addProlongCalculate = (bodyProlong, bodyDeposit, bodyReport) => ({
  type: ADD_PROLONGCALCULATE_REQUESTED,
  payload: {
    bodyProlong,
    bodyDeposit,
    bodyReport
  }
})

export const addProlongCalculateSuccess = payload => ({
  type: ADD_PROLONGCALCULATE_SUCCESS,
  payload
})

export const addProlongCalculateFailed = payload => ({
  type: ADD_PROLONGCALCULATE_FAILED,
  payload
})

export const stateContractReset = () => ({
  type: CONTRACT_STATE_RESET
})

export const resetSave = () => ({
  type: CONTRACT_SAVE_RESET
})

export const changeClientContract = (contractId, data, clientId) => ({
  type: CHANGE_CLIENTCONTRACT_REQUESTED,
  contractId,
  data,
  clientId
})

export const changeClientContractSuccess = () => ({
  type: CHANGE_CLIENTCONTRACT_SUCCESS
})

export const changeClientContractFailed = payload => ({
  type: CHANGE_CLIENTCONTRACT_FAILED,
  payload,
})

export const getOperations = dealId => ({
  type: GET_OPERATIONSCONTRACT_REQUESTED,
  dealId
})

export const getOperationsSuccess = payload => ({
  type: GET_OPERATIONSCONTRACT_SUCCESS,
  payload
})

export const getOperationsFailed = payload => ({
  type: GET_OPERATIONSCONTRACT_FAILED,
  payload
})

export const changeContractStatuses = (dealIds, newStatus, transferIds = null, transfersStatus = null, feature, userCashBox) => ({
  type: CHANGE_CONTRACTSTATUSES_REQUESTED,
  payload: {
    dealIds,
    newStatus,
    transferIds,
    transfersStatus,
  },
  feature,
  userCashBox
})

export const changeContractStatusesRefund = (data, userCashBox) => ({
  type: CHANGE_CONTRACTSTATUSES_REFUND_REQUESTED,
  payload: {
    data
  },
  userCashBox
})

export const changeContractStatusesClose = (data, transactions) => ({
  type: CHANGE_CONTRACTSTATUSES_CLOSE_REQUESTED,
  payload: {
    data
  },
  transactions
})

export const changeContractStatusesSuccess = () => ({
  type: CHANGE_CONTRACTSTATUSES_SUCCESS
})

export const changeContractStatusesFailed = payload => ({
  type: CHANGE_CONTRACTSTATUSES_FAILED,
  payload
})

export const getTransactions = (payload) => ({
  type: GET_TRANSACTIONS_REQUESTED,
  payload
})

export const getPaymentPeriodAnnuity = (payload) => ({
  type: GET_PAYMENTS_ANNUITY_REQUESTED,
  payload
})

export const getCalcAnnuityCloseDeal = (payload) => ({
  type: GET_CALC_ANNUITY_CLOSE_DEAL_REQUESTED,
  payload
})

export const changeStateAnnuityClose = () => ({
  type: CLOSE_ANNUITY_STATE,
})

export const changeStateAnnuityPeriod = () => ({
  type: ANNUITY_PERIOD_STATE,
})

export const getCalcAnnuityCloseDealSuccess = (payload) => ({
  type: GET_CALC_ANNUITY_CLOSE_DEAL_SUCCESS,
  payload
})
export const getCalcAnnuityCloseDealFailed = (payload) => ({
  type: GET_CALC_ANNUITY_CLOSE_DEAL_FAILED,
  payload
})

export const closeDealAnnuity = (payload) => ({
  type: CLOSE_ANNUITY_DEAL_REQUESTED,
  payload
})

export const closeDealAnnuitySuccess = (payload) => ({
  type: CLOSE_ANNUITY_DEAL_SUCCESS,
  payload
})
export const closeDealAnnuityFailed = (payload) => ({
  type: CLOSE_ANNUITY_DEAL_FAILED,
  payload
})

export const getTransactionsSuccess = payload => ({
  type: GET_TRANSACTIONS_SUCCESS,
  payload
})

export const getPaymentsAnnuitySuccess = payload => ({
  type: GET_PAYMENTS_ANNUITY_SUCCESS,
  payload
})

export const payAnnuityPeriodSuccess = payload => ({
  type: PAY_ANNUITY_PERIOD_SUCCESS,
  payload
})

export const payAnnuityPeriodFailed = payload => ({
  type: PAY_ANNUITY_PERIOD_FAILED,
  payload
})

export const payAnnuityPeriod = payload => ({
  type: PAY_ANNUITY_PERIOD_REQUESTED,
  payload
})

export const getTransactionsFailed = payload => ({
  type: GET_TRANSACTIONS_FAILED,
  payload
})

export const getPaymentsAnnuityFailed = payload => ({
  type: GET_PAYMENTS_ANNUITY_FAILED,
  payload
})

export const changePositionsContract = (data, dealId) => ({
  type: CHANGE_POSITIONSCONTRACT_REQUESTED,
  payload: { data, dealId }
})

export const changePositionsContractSuccess = payload => ({
  type: CHANGE_POSITIONSCONTRACT_SUCCESS,
  payload
})

export const changePositionsContractFailed = payload => ({
  type: CHANGE_POSITIONSCONTRACT_FAILED,
  payload,
})

export const transferDeals = (data, viewReport, filename, name, identity) => ({
  type: TRANSFER_DEALS_REQUESTED,
  payload: data,
  viewReport,
  filename,
  name,
  identity
})

export const transferDealsSuccess = payload => ({
  type: TRANSFER_DEALS_SUCCESS,
  payload
})

export const transferDealsFailed = payload => ({
  type: TRANSFER_DEALS_FAILED,
  payload,
})

export const getInventories = (size, page, type, descending, sortBy, status, cashbox, dealDuration, clientIds, transferIds, dealTypes, delayFrom, delayTo) => {
  if (status === contractStatuses.GOHRAN_SALE.param) {
    return {
      type: GET_INVENTORIES_REQUESTED,
      payload: {
        size,
        page,
        filters: {
          type,
          cashbox,
          clientIds,
          dealDuration,
          transferIds,
          dealTypes,
          delayFrom,
          delayTo
        },
        descending,
        sortBy,
      }
    }
  }
  return {
    type: GET_INVENTORIES_REQUESTED,
    payload: {
      size,
      page,
      filters: {
        type,
        status,
        cashbox,
        dealDuration,
        clientIds,
        transferIds,
        dealTypes,
        delayFrom,
        delayTo
      },
      descending,
      sortBy,
    }
  }
}
export const getInventoriesSuccess = payload => ({
  type: GET_INVENTORIES_SUCCESS,
  payload,
})

export const getInventoriesFailed = payload => ({
  type: GET_INVENTORIES_FAILED,
  payload,
})

export const getInventoryDeals = (size, page, transferId, status, descending) => ({
  type: GET_INVENTORYDEALS_REQUESTED,
  payload: {
    size,
    page,
    descending,
    filters: { transferId, status }
  }
})

export const getInventoryDealsSuccess = payload => ({
  type: GET_INVENTORYDEALS_SUCCESS,
  payload,
})

export const getInventoryDealsFailed = payload => ({
  type: GET_INVENTORYDEALS_FAILED,
  payload,
})

export const getDealsForTransfer = payload => ({
  type: GET_DEALSFORTRANSFER_REQUESTED,
  payload,
})

export const getDealsForTransferSuccess = payload => ({
  type: GET_DEALSFORTRANSFER_SUCCESS,
  payload,
})

export const getDealsForTransferFailed = payload => ({
  type: GET_DEALSFORTRANSFER_FAILED,
  payload,
})

export const transferSaled = (items) => {
  if (items.data) {
    return {
      type: TRANSFER_SALED_REQUESTED,
      payload: {
        ...items.data,
        dealIds: items.dealIds,
        transferIds: items.transferIds,
        getJsonFile: items.getJsonFile,
      },
      status: items.status,
      feature: items.feature
    }
  }
  return {
    type: TRANSFER_SALED_REQUESTED,
    payload: {
      dealIds: items.dealIds,
      transferIds: items.transferIds,
      cash: items.cash,
      cashBoxId: items.cashBoxId,
      getJsonFile: items.getJsonFile,
      deposit: items.deposit,
    },
    status: items.status,
    feature: items.feature
  }
}

export const transferSaledSuccess = payload => ({
  type: TRANSFER_SALED_SUCCESS,
  payload,
})

export const transferSaledFailed = payload => ({
  type: TRANSFER_SALED_FAILED,
  payload,
})

export const getDealToRetention = (payload) => ({
  type: TRANSFER_TO_RETENTION_REQUESTED,
  payload
})

export const getDealToRetentionSuccess = payload => ({
  type: TRANSFER_TO_RETENTION_SUCCESS,
  payload,
})

export const getDealToRetentionFailed = payload => ({
  type: TRANSFER_TO_RETENTION_FAILED,
  payload,
})

export const overestimationDeals = (bodyOverestimation, bodyReport = false) => ({
  type: OVERESTIMATION_DEALS_REQUESTED,
  payload: {
    bodyOverestimation,
    bodyReport
  }
})

export const overestimationDealsSuccess = payload => ({
  type: OVERESTIMATION_DEALS_SUCCESS,
  payload,
})

export const overestimationRequestSuccess = payload => {
  return {
    type: OVERESTIMATION_REQUEST_SUCCESS,
    payload
  }
}

export const overestimationDealsFailed = payload => ({
  type: OVERESTIMATION_DEALS_FAILED,
  payload,
})

export const cancelOperation = (payload) => ({
  type: CANCEL_OPERATION_REQUESTED,
  payload,
})

export const cancelOperationSuccess = payload => ({
  type: CANCEL_OPERATION_SUCCESS,
  payload,
})

export const cancelOperationFailed = payload => ({
  type: CANCEL_OPERATION_FAILED,
  payload,
})

export const getPrintedForm = (reqBody, filename, viewReport, type = 'pdf', operationId) => ({
  type: GET_PRINTEDFORM_REQUEST,
  payload: {
    reqBody,
    filename,
    viewReport,
    type,
    operationId
  }
})

export const getPrintedFormAutoLombard = (dealId, fileName, type = 'pdf') => ({
  type: GET_PRINTED_FORM_AUTO_LOMBARD_REQUEST,
  payload: {
    type,
    dealId,
    fileName
  }
})

export const getPrintedFormSuccess = payload => ({
  type: GET_PRINTEDFORM_SUCCESS,
  payload
})

export const getPrintedFormFailed = payload => ({
  type: GET_PRINTEDFORM_FAILED,
  payload
})

export const getClientsCount = (reqBody, viewReport) => ({
  type: GET_CLIENTSCOUNT_RERQUEST,
  payload: {
    reqBody,
    viewReport,
  }
})

export const getClientsCountSuccess = payload => ({
  type: GET_CLIENTSCOUNT_SUCCESS,
  payload
})

export const getClientsCountFailed = payload => ({
  type: GET_CLIENTSCOUNT_FAILED,
  payload
})

export const resetClientsCount = () => ({
  type: RESET_CLIENTS_COUNT,
});

export const clearProlongCalculate = () => ({
  type: PROLONG_CALCULATE_CLEAR
})

export const clearChangeContract = () => ({
  type: CHANGE_CONTRACT_CLEAR
})

export const clearContractID = () => ({
  type: CONTRACT_ID_CLEAR
})

export const clearModalError = () => ({ type: MODAL_ERROR_CLEAR })

export const setModalError = payload => ({
  type: SET_MODAL_ERROR,
  payload
})

export const clearClientContract = () => ({ type: CLIENT_CONTRACT_CLEAR })

export const cancelContract = payload => ({
  type: CANCEL_CONTRACT_REQUEST,
  payload
})

export const cancelContractSuccess = payload => ({
  type: CANCEL_CONTRACT_SUCCESS,
  payload
})

export const cancelContractFailed = payload => ({
  type: CANCEL_CONTRACT_FAILED,
  payload
})

export const contractTypeJewellery = payload => ({
  type: SWITCH_CONTRACT_JEWELLERY,
  payload
})

export const contractTypeThings = payload => ({
  type: SWITCH_CONTRACT_THINGS,
  payload
})

export const contractTypeCars = payload => ({
  type: SWITCH_CONTRACT_CARS,
  payload
})

export const clearContractError = payload => ({
  type: CONTRACT_ERROR_CLEAR,
  payload
})

export const getWebFormSuccess = payload => ({
  type: GET_WEB_FORM_SUCCESS,
  payload
})

export const resetWebForm = () => ({
  type: RESET_WEB_FORM
})

export const getPartialQuenchingData = (payload) => {
  return {
    type: GET_PARTIAL_QUENCHING_DATA_REQUESTED,
    payload,
  }
}

export const getPartialQuenchingDataSuccess = payload => ({
  type: GET_PARTIAL_QUENCHING_DATA_SUCCESS,
  payload,
})

export const getPartialQuenchingDataFailed = payload => ({
  type: GET_PARTIAL_QUENCHING_DATA_FAILED,
  payload,
})

export const clearPartialQuenchingData = () => ({
  type: PARTIAL_QUENCHING_DATA_CLEAR,
})

export const contractPartialQuenching = (payload) => ({
  type: CONTRACT_PARTIAL_QUENCHING_REQUESTED,
  payload,
})

export const contractPartialQuenchingSuccess = payload => ({
  type: CONTRACT_PARTIAL_QUENCHING_SUCCESS,
  payload,
})

export const contractPartialQuenchingFailed = payload => ({
  type: CONTRACT_PARTIAL_QUENCHING_FAILED,
  payload,
})

